
export const IS_PWA_INSTALLATION_CANCELLED = 'IsPWAInstallationCancelled';
export const AUTH_TOKEN = 'idaw-token';
export const LAST_REQUEST_ID = 'idaw-last-request-id';
export const FIRST_ROUTE_TO_NAVIGATE_AFTER_SIGN_IN = '/';
export const TENANT = 'doxautoinscripcion';
